import styled from "styled-components";
import {CloseButton} from "../Modal/styled";

export const SpacerStyled = styled.div`
  width: ${props => props.width ? props.width + 'px' : 0};
  height: ${props => props.height ? props.height + 'px' : 0};
`;

export const ContentAwardStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ContentInfoAwardStyled = styled.div`
    display: flex;
    flex-direction: column;
`;